import { USER_ROLE } from '@app/modules/user/consts/role';

export const isUserRoleExist = (role: string): boolean => Object.keys(USER_ROLE).indexOf(role) !== -1;
